import React, {
	createContext,
	useContext,
	useState,
	useEffect,
	useMemo,
} from "react";

const DataCtx = createContext(null);

export const useVehicleData = () => {
	const ctx = useContext(DataCtx);
	if (!ctx)
		throw new Error(
			"useVehicleData must be used inside VehicleDataProvider"
		);
	return ctx;
};

export const VehicleDataProvider = ({
	deviceId,
	chassisNum,
	selectedVehicle: selectedVehicleProp, // accept it
	children,
}) => {
	const [canSnapshot, setCanSnapshot] = useState(null);
	const [alerts, setAlerts] = useState([]);
	const [selectedVehicle, setSelectedVehicle] = useState(
		selectedVehicleProp || null
	);

	// reset CAN + alerts when identity changes
	useEffect(() => {
		setCanSnapshot(null);
		setAlerts([]);
	}, [deviceId, chassisNum]);

	// keep context.selectedVehicle in sync with prop
	useEffect(() => {
		setSelectedVehicle(selectedVehicleProp || null);
	}, [selectedVehicleProp]); // or [selectedVehicleProp?.id] if large

	const value = useMemo(
		() => ({
			deviceId,
			chassisNum,
			canSnapshot,
			setCanSnapshot,
			alerts,
			setAlerts,
			selectedVehicle,
			setSelectedVehicle,
		}),
		[deviceId, chassisNum, canSnapshot, alerts, selectedVehicle]
	);

	return <DataCtx.Provider value={value}>{children}</DataCtx.Provider>;
};
